import { Button } from '@mui/material'
import React from 'react'

const PrimaryButton = ({children, ...props}) => {
  return (
    <Button 
        color="primary" 
        variant="outlined"
        {...props}
    >
    {children}
  </Button>
  )
}

export default PrimaryButton